import React, { useContext, useEffect, useState } from "react";
import defaultUserPic from "../../assets/img/user-profile.svg";
import groupPic from "../../assets/img/multi-user-icon.svg";
import * as chatService from "../../services/chatService";
import { ChatListDataContext, GroupDataContext, SignalRContext } from "../../layout/Baselayout";
import { toast } from "react-toastify";
import { getFormattedDateTime, parseDate } from "../../utils";

const NewGroup = ({ closeModal, allUserList, loginUserData, currGroup, action, selectedForwardMessages }) => {
  const {chatListItem, setChatListItem, activeChats, setActiveChats} = useContext(ChatListDataContext);
  const [activeGroups, setActiveGroups] = useContext(GroupDataContext);
  const [connection] = useContext(SignalRContext)
  const [userIds, setUserIds] = useState([]);
  const [groupName, setGroupName] = useState("");
  const [searchUser, setSearchUser] = useState("");
  const [filteredUserList, setFilteredUserList] = useState(allUserList);
  const [viewMembersList, setViewMembersList] = useState([]);
  const [showUserList, setShowUserList] = useState(null);
  const [currentGroup, setCurrentGroup] = useState(currGroup);

  const headerTitle = {
    add: "Create New Group",
    update: "Update Group",
    viewMembers: currGroup?.groupName,
    forward: "Forword message to"
  }

  const handleOnUserChange = (event, userId) => {
    if (event.target.checked) {
      setUserIds((prevSelected) => [...prevSelected, userId]);
    } else {
      setUserIds((prevSelected) =>
        prevSelected.filter((user) => user !== userId)
      );
    }
  };

  const handleGetGroupById = async () => {
    let response = await chatService.getGroup(currGroup?.id);
    setCurrentGroup(response);
    setGroupName(response.groupName);
    setUserIds(response.users.split(",").map(Number));
    setShowUserList(response.viewMembers);
  }

  useEffect(() => {
    if (currGroup?.id) {
      handleGetGroupById();
    } else if (action === 'add') {
      setShowUserList(true);
    }
  }, [currGroup?.id]);

  const getAllUsers = async () => {
    let response = await chatService.getAllUsers();
    const viewMembersList = response.filter((user) => userIds.includes(user?.id))
    setViewMembersList(viewMembersList);
  }

  useEffect(() => {
    if (showUserList && action === "viewMembers" || (currentGroup?.createdBy === loginUserData.id && action === "viewMembers")) {
      getAllUsers();
    }
  }, [showUserList, userIds])

  const handleCreateGroupClick = async () => {
    if (userIds.length < 2) {
      toast.error("Minimum select 2 users are required.");
      return;
    }
    if (groupName === "") {
      toast.error("Group Name is required.");
      return;
    }
    if (currGroup?.id) {
      const data = {
        adminId: loginUserData?.adminId,
        groupName: groupName,
        users: userIds.join(','),
        ViewMembers: showUserList,
        groupId: currGroup?.id
      }
      try {
        let response = await chatService.updateGroup(data);
        setChatListItem({
          id: response?.id,
          groupName: response?.groupName,
          type: "update-group-item",
        });
        toast.success("Update group successfully");
        closeModal();
      } catch (error) {
        console.error("Error in creating group", error);
      }
    } else {
      const data = {
        adminId: loginUserData?.adminId,
        groupName: groupName,
        users: [...userIds, loginUserData.id].join(','),
        ViewMembers: showUserList
      }
      try {
        let response = await chatService.addGroup(data);

        if (response.status === 201) {
          let result = await response.json();
          toast.success("Group is created");
          // if(response.status)
          // setChatListItem({
          //   id: result?.id,
          //   groupName: result?.groupName,
          //   roomId: result?.roomId,
          //   users: [...userIds, loginUserData.id],
          //   lastMessageDate: result?.lastMessageDate ? result?.lastMessageDate : result?.createdAt,
          //   type: "add-group-item",
          // });
          // setActiveGroups((prev) => [...prev, result]);
        }
        closeModal();
      } catch (error) {
        console.error("Error in creating group", error);
      }
    }
  }

  //forward message
  const showUserForForwardMsg = () => {
    const activeIds = new Set([...activeChats.map(item => item.id)]);

    const filteredAllUserList = allUserList.filter(item => !activeIds.has(item.id));

    const combined = [...activeChats, ...activeGroups, ...filteredAllUserList];

    const sortedCombined = combined.sort(
      (a, b) => parseDate(b.lastMessageDate) - parseDate(a.lastMessageDate)
    );

    const uniqueCombined = Array.from(
      new Map(sortedCombined.map(item => [item.id, item])).values()
    );

    setFilteredUserList(uniqueCombined);
  };

  useEffect(() => {
    if (action === 'forward') {
      showUserForForwardMsg();
    }
  }, [activeChats, activeGroups, allUserList])

  const handleForwarMessage = async () => {
    // Filter users based on selected userIds
    const userDetail = filteredUserList.filter((user) => userIds.includes(user.id));

    // Process each message for each user
    for (const user of userDetail) {
      for (const message of selectedForwardMessages) {
        const msgData = {
          senderId: loginUserData?.id,
          receiverId: user.type === "Group Chat" ? 0 : user.id,
          roomId: user?.roomId ?? '',
          message: message.message,
          mediaUrl: message.mediaUrl,
          senderName: loginUserData?.userName,
        };

        try {
          if (user.type === "Group Chat") {
            // Send group message
            await connection.invoke("SendRoomMessage", msgData);
          } else {
            // Send private message
            await connection.invoke("SendMessage", msgData);
            setChatListItem({
              id: user.id,
              userName: user.userName,
              roomId: user.roomId ? user.roomId : "",
              type: "add-chat-item-fwd",
              lastMessageDate: getFormattedDateTime(),
              message: msgData.message
            });
          }
          closeModal();
        } catch (error) {
          console.error('Error sending message:', error);
          // You might want to handle errors here (retry, notify user, etc.)
        }
      }
    }
  };

  const handleOnSearch = (event) => {
    const searchData = event.target.value;
    setSearchUser(searchData);
    const filterData = allUserList?.filter((item) => {
      return item.userName.toLowerCase().includes(searchData?.toLowerCase());
    });
    setFilteredUserList(filterData);
  }

    /*-----------close model on esc ------------*/
  useEffect(() => {
      const handleKeyDown = (e) => {
        if (e.key === "Escape") {
          closeModal();
        }
      };
    
      window.addEventListener("keydown", handleKeyDown);
    
      return () => {
        window.removeEventListener("keydown", handleKeyDown);
      };
    }, [closeModal]);


  return (
    <div className="modal-content Create-new-group-popup">
      <div className="modal-header">

        <label>{headerTitle[action]}</label>
        <i
          className="fa fa-times-circle cursor-pointer"
          aria-hidden="true"
          onClick={closeModal}
        ></i>
      </div>
      <div className="modal-body">
        {action !== "viewMembers" && <div className="groupcreate-new">
          <input
            type="text"
            placeholder="Search users"
            value={searchUser}
            onChange={handleOnSearch}
          />
        </div>}
        {action !== "viewMembers" ? (
          <>
            {filteredUserList && filteredUserList.length > 0 ? (
              filteredUserList.map((user) => {
                if (user?.id === loginUserData?.id) {
                  return null;
                }
                return (
                  <div key={user?.id}>
                    <div className="modal-usercontainer">
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className="sideBar-avatar group-textleft">
                          <div className="avatar-icon">
                            <img src={user?.type === "Group Chat" ? groupPic : defaultUserPic} alt={user?.userName} />
                            <label>{user.type==="Group Chat"? user?.groupName:user?.userName}</label>
                          </div>
                        </div>
                      </div>
                      <input
                        type="checkbox"
                        value={userIds}
                        className="inputwidth"
                        checked={userIds.includes(user.id)} // Check if user ID is in userIds
                        onChange={(event) => handleOnUserChange(event, user?.id)}
                      />
                    </div>
                  </div>
                );
              })
            ) : (
              <div>No users available</div>
            )}
          </>
        ) : (
          <>
            {currentGroup?.viewMembers || currentGroup?.createdBy === loginUserData.id ? (viewMembersList && viewMembersList.length > 0 ? (
              viewMembersList.map((user) => {
                if (user?.id === loginUserData?.id) {
                  return null;
                }
                return (
                  <div key={user?.id}>
                    <div className="modal-usercontainer">
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className="sideBar-avatar group-textleft">
                          <div className="avatar-icon">
                            <img src={defaultUserPic} alt={user?.userName} />
                            <label>{user?.userName}</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div>Loading...</div>
            )) : <div> You don't have access to view members</div>}
          </>
        )}
      </div>
      {action !== "viewMembers" && (
        <>
          {action !== "forward" ? (
            <>
              <div className="d-flex align-items-center my-3" style={{ cursor: "pointer" }} onClick={() => setShowUserList(!showUserList)}>
                <span className="fw-bold" style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", paddingRight: 10 }}>
                  View members
                  <i className={`fa ${showUserList ? "fa-toggle-on" : "fa-toggle-off"} fa-2x me-2`} style={{ color: "#00a884", padding: "5px", borderRadius: "5px" }}></i>
                </span>
              </div>

              <div className="modal-footer modal-footer-groupcreate">
                <input
                  type="text"
                  placeholder="Group Name"
                  value={groupName}
                  onChange={(event) => setGroupName(event.target.value)}
                />
                <button className="btn btn-success" type="button" aria-haspopup="true" onClick={handleCreateGroupClick}>
                  {currGroup?.id ? "Update Group" : "Create Group"}
                </button>
              </div>
            </>
          ) : (
            <div className="modal-footer modal-footer-groupcreate">
              <button className="modal-action-button" onClick={handleForwarMessage}>Send</button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default NewGroup;
